import React from 'react'
import { StaticQuery, graphql } from 'gatsby';
import { withPreview } from '@prismicio/gatsby-source-prismic-graphql';
import { RichText } from 'prismic-reactjs'
import get from 'lodash/get';

import { RichLinks, RichContent } from '../../utils/html'
import { getLinkPropsFromReference } from '../../utils/link'

import { Container, Navigation, NavigationList, NavigationListItem, Link, Group, GroupHeader, GroupList, GroupListItem, BottomContainer, BottomInner, LegalContent, Legal, Social, SocialList, SocialItem, SocialLink, SocialIcon } from './footer.styles'

const footerQuery = graphql`
query {
	prismic {
		allFooters {
			edges {
				node {
					_meta{
						lang
					}
					legal
					social {
						icon
						color
						link {
							_linkType
							... on PRISMIC_Home {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Complex {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Simple {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Product {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Article {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Blog {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Contact {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Form {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Legal {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC__ExternalLink {
								url
							}
							... on PRISMIC__FileLink {
								url
							}
							... on PRISMIC__ImageLink {
								url
							}
						}
					}
					body {
						... on PRISMIC_FooterBodyGroup {
							type
							primary {
								label
								link {
									_linkType
									... on PRISMIC_Home {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Complex {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Simple {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Product {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Article {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Blog {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Contact {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Form {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Legal {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC__ExternalLink {
										url
									}
									... on PRISMIC__FileLink {
										url
									}
									... on PRISMIC__ImageLink {
										url
									}
								}
							}
							fields {
								label
								link {
									_linkType
									... on PRISMIC_Home {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Complex {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Simple {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Product {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Article {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Blog {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Contact {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Form {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Legal {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC__ExternalLink {
										url
									}
									... on PRISMIC__FileLink {
										url
									}
									... on PRISMIC__ImageLink {
										url
									}
								}
							}
						}
						... on PRISMIC_FooterBodyLink {
							type
							primary {
								label
								link {
									_linkType
									... on PRISMIC_Home {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Complex {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Simple {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Product {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Article {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Blog {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Contact {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Form {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Legal {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC__ExternalLink {
										url
									}
									... on PRISMIC__FileLink {
										url
									}
									... on PRISMIC__ImageLink {
										url
									}
								}
							}
						}
					}
				}
			}
		}
	}
}
`;

const renderBody = (body) => {
	if(body){
		return body.map((item, index) => {
			switch(item.type){
				case 'group': return (
					<NavigationListItem key={index}>
						{renderGroup(item.primary,item.fields)}
					</NavigationListItem>
				)
				case 'link': return (
					<NavigationListItem key={index}>
						<Link {...getLinkPropsFromReference(item.primary.link)}>{item.primary.label}</Link>
					</NavigationListItem>
				)
			}
			return null;
		})
	}
	return null;
}

const renderGroup = (primary,fields) => {
	if(primary && fields){
		return(
			<Group>
				<GroupHeader>
					<Link {...getLinkPropsFromReference(primary.link)}>{primary.label}</Link>
				</GroupHeader>
				<GroupList>
					{fields.map((field,index) => (
						<GroupListItem key={index}>
							<Link {...getLinkPropsFromReference(field.link)}>{field.label}</Link>
						</GroupListItem>
					))}
				</GroupList>
			</Group>
		)
	}
	return null;
}

const renderSocialItems = (items) => {
	if(items){
		return items.map((item, index) => {
			if(item.icon && item.link){
				return (
					<SocialItem key={index}>
						<SocialLink {...getLinkPropsFromReference(item.link)}>
							<SocialIcon src={item.icon.url} brandColor={item.color} />
						</SocialLink>
					</SocialItem>
				)
			}
			
			return null;
		})
	}
	return null;
}

const Footer = ({language}) => (
	<StaticQuery
		query={`${footerQuery}`}
		render={withPreview(data => {
			const footer = get(data,"prismic.allFooters.edges",[]).find(edge => edge.node._meta.lang === language);

			// check all relevant content exists
			if(!footer) return null;

			const body = footer.node.body.slice(0,4);

			return (
				<Container>
					<Navigation>
						<NavigationList>
							{renderBody(body)}
							<Social space={5 - body.length}>
								<SocialList>
									{renderSocialItems(footer.node.social)}
								</SocialList>
							</Social>
						</NavigationList>
					</Navigation>
					
					<BottomContainer>
						<BottomInner>
							<LegalContent>
								<Legal><RichContent render={footer.node.legal} /></Legal>
							</LegalContent>
						</BottomInner>
					</BottomContainer>
				</Container>
			)

		}, footerQuery)}
	/>
);

export default Footer;